<!-- TEMPLATE -->
<template>
  <v-dialog v-model="showDialog" width="50%" persistent>
    <v-card>
      <v-card-title class="headline">
        Add a phishing domain manually
      </v-card-title>
      <v-card-text>
        Great! Let's take it down together. Please provide all the information I
        need to respond to this phishing campaign

        <v-container>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-text-field
                label="Phishing domain (subdomain.phishingdomain.com)"
                v-model="domain"
                required
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
        <v-container>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-text-field
                label="Phishing URL to the clone (https://subdomain.phishingdomain.com/route/to/index)"
                v-model="url"
                required
                >Full URL</v-text-field
              >
            </v-col>
          </v-row>
        </v-container>
        <v-container>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-label>Select the cloned domain</v-label>
              <DomainListDropdown style="color: black" />
            </v-col>
          </v-row>
        </v-container>
        <small>all fields are mandatory</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="ma-1 btn" dark @click="addPhishingDomain(domain, url)">
          Add
        </v-btn>
        <v-btn class="ma-1 btn" dark @click="showDialog = false"> Close </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<!-- SCRIPT -->
<script>
import PhishingApi from "../app/phishing-api";
import DomainListDropdown from "./DomainListDropdown.vue";

export default {
  name: "DialogAddPhishingDomain",
  data: function () {
    return {
      userInfo: this.$store.state.cognitoInfo,
      url: null,
      domain: null,
      original: null,
      domains: null,
      show: false,
    };
  },

  created() {},
  methods: {
    addPhishingDomain(domain, url) {
      let self = this;
      let original = self.$store.getters.activeDomain;
      PhishingApi.addPhishingWebsite(domain, url, original).then(function (
        value
      ) {
        self.$store.dispatch("refreshPhishingWebsites");
        self.$store.dispatch("refreshGraphs");
        self.url = "";
        self.domain = "";
        self.showDialog = false;
      });
    },
  },
  computed: {
    showDialog: {
      get: function () {
        return this.show;
      },
      set: function (newValue) {
        this.$emit("update:show", newValue);
      },
    },
  },
  props: ["show"],
  components: {
    DomainListDropdown,
  },
};
</script>

<!-- Style -->
<style>
</style>